<div class="wrapper" #wrapper>
  <div class="full-screen-loader" *ngIf="isStudioProjectLoading$ | async">
    <app-project-preview-loading
      [text]="'The project is being loaded...'"
    ></app-project-preview-loading>
  </div>
  <div
    class="studio-content"
    [style.opacity]="(isStudioProjectLoading$ | async) ? 0 : 1"
  >
    <!-- Left: Input files with text and media -->
    <div class="left">
      <div class="left-content">
        <nw-layout-settings></nw-layout-settings>
      </div>
    </div>

    <!-- Middle: Canvas (centered vertically, no extra wrapper) -->
    <div class="middle" #middle>
      <nw-background-settings-modal
        *ngIf="showBgModal"
        [sceneIndexOptions]="sceneIndexOptions"
        [(startIndex)]="bgStartIndex"
        [(endIndex)]="bgEndIndex"
        [(type)]="bgType"
        (cancel)="closeBgModal()"
        (save)="onBgModalSave($event)"
      ></nw-background-settings-modal>

      <nw-layout-settings-modal
        *ngIf="showLayoutModal"
        [sceneIndexOptions]="sceneIndexOptions"
        [(startIndex)]="layoutStartIndex"
        [(endIndex)]="layoutEndIndex"
        [(type)]="layoutType"
        [(baseMargin)]="layoutBaseMargin"
        (cancel)="closeLayoutModal()"
        (save)="setLayout($event)"
      ></nw-layout-settings-modal>

      <nw-text-edit-modal
        *ngIf="textEditModalConfig"
        [id]="textEditModalConfig.id"
        [value]="textEditModalConfig.text"
        (cancel)="textEditModalConfig = null"
        (saveFull)="onTextModalSaveFull($event)"
      ></nw-text-edit-modal>

      <nw-image-upload-modal
        *ngIf="showImageUploadModal"
        (cancel)="closeImageUploadModal()"
        (upload)="onImageUpload($event)"
      ></nw-image-upload-modal>

      <div
        style="width: -webkit-fill-available; height: -webkit-fill-available"
      >
        <iw-canvas></iw-canvas>
        <nw-video-controls></nw-video-controls>
        <div (click)="export()">Export</div>
        <!-- <nw-video-edit-prompt></nw-video-edit-prompt> -->
      </div>
      <!-- <div>
          <div>Project</div>
          <div class="flex-row gap-4">
            <nw-file-project-settings
              label="Complete"
              [completeProject]="true"
            ></nw-file-project-settings>
            <nw-file-project-settings
              label="Background"
              [projectKey]="'backgroundDefinitions'"
            ></nw-file-project-settings>
          </div>
          <div>Scene</div>
          <div class="flex-row gap-4">
            <nw-file-project-settings
              label="Complete"
              [completeFile]="true"
            ></nw-file-project-settings>
            <nw-file-project-settings
              label="Animations"
              [fileKey]="'textAnimationStep'"
            ></nw-file-project-settings>
            <nw-file-project-settings
              label="Content"
              [fileKey]="'content'"
            ></nw-file-project-settings>

            <nw-text-animation-editor></nw-text-animation-editor>
          </div>
        </div> -->

      <!-- <nw-video-setting-tabs></nw-video-setting-tabs> -->
    </div>

    <!-- Right: Scene input -->
    <div class="right slides-vertical canvas-wrap">
      <div>
        <nw-scene-input></nw-scene-input>
      </div>
    </div>
  </div>

  <!-- <nw-media-preview-modal
    [videoInstance]="selectedMedia$ | async"
  ></nw-media-preview-modal> -->
</div>
